import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-463">
      <div className="max-w-4xl mx-auto" data-id="element-464">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-465">
          Lo que <span className="text-[#00E68A] italic" data-id="element-466">recibís</span>
        </h2>

        {/* Main card */}
        <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 sm:p-10 mb-10" data-id="element-467">
          <h3 className="text-[#00E68A] text-xl sm:text-2xl font-black mb-1" data-id="element-468">
            📗 1° a 6° Año — 6 TOMOS
          </h3>
          <p className="text-gray-400 text-sm sm:text-base mb-8" data-id="element-469">
            Para docentes de Lengua y Literatura de secundaria
          </p>

          <div className="space-y-6" data-id="element-470">
            <div className="flex items-start gap-3" data-id="element-471">
              <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-472">📘</span>
              <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-473">
                <strong data-id="element-474">Tomo 1 — 1° Año: Leer el mundo</strong>{' '}
                <span className="text-gray-300" data-id="element-475">
                  Narrativa literaria, escritura creativa y análisis textual.
                  Secuencias completas con solucionario.
                </span>
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-476">
              <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-477">📗</span>
              <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-478">
                <strong data-id="element-479">Tomo 2 — 2° Año: Lengua viva</strong>{' '}
                <span className="text-gray-300" data-id="element-480">
                  Géneros discursivos y literatura regional argentina.
                  Actividades listas para imprimir.
                </span>
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-481">
              <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-482">📙</span>
              <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-483">
                <strong data-id="element-484">Tomo 3 — 3° Año: Otras voces, otros mundos</strong>{' '}
                <span className="text-gray-300" data-id="element-485">
                  Literatura latinoamericana y producción de sentido.
                  Evaluaciones con rúbricas incluidas.
                </span>
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-486">
              <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-487">📕</span>
              <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-488">
                <strong data-id="element-489">Tomo 4 — 4° Año: El poder de la palabra</strong>{' '}
                <span className="text-gray-300" data-id="element-490">
                  Argumentación, retórica y discurso social. Secuencias paso a
                  paso.
                </span>
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-491">
              <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-492">📓</span>
              <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-493">
                <strong data-id="element-494">Tomo 5 — 5° Año: Literatura y sociedad</strong>{' '}
                <span className="text-gray-300" data-id="element-495">
                  Literatura universal y producción académica. Portfolio y
                  autoevaluación.
                </span>
              </p>
            </div>

            <div className="flex items-start gap-3" data-id="element-496">
              <span className="text-2xl mt-0.5 flex-shrink-0" data-id="element-497">📔</span>
              <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-498">
                <strong data-id="element-499">Tomo 6 — 6° Año: Voz propia</strong>{' '}
                <span className="text-gray-300" data-id="element-500">
                  Crítica literaria, ensayo y construcción de identidad.
                  Solucionario completo y planificación anual.
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 sm:p-8 text-center" data-id="element-501">
          <h3 className="text-[#00E68A] text-xl font-black mb-6" data-id="element-502">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-503">
            <div className="flex items-start gap-2 text-left" data-id="element-504">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-505">✅</span>
              <span className="text-white text-sm" data-id="element-506">
                Planificación anual + 4 unidades didácticas completas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-507">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-508">✅</span>
              <span className="text-white text-sm" data-id="element-509">
                Secuencias paso a paso y actividades listas para imprimir
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-510">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-511">✅</span>
              <span className="text-white text-sm" data-id="element-512">
                Evaluaciones trimestrales + diagnóstica con rúbricas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-513">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-514">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-515">
                SOLUCIONARIO COMPLETO con todas las respuestas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-516">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-517">✅</span>
              <span className="text-white text-sm" data-id="element-518">
                Autoevaluación, portfolio y bibliografía oficial
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-519">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-520">✅</span>
              <span className="text-white text-sm" data-id="element-521">
                100% alineado a NAP y Diseños Curriculares provinciales
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}